import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getFulfillmentGroupForShippingClaim = {
  name: "getFulfillmentGroupForShippingClaim" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({
    recipientName: z.string().nullish(),
    recipientEmail: z.string().nullish(),
    recipientPhone: z.string().nullish(),
    lineItems: z
      .array(
        z.object({
          title: z.string(),
          productTitle: z.string().nullish(),
          variantTitle: z.string(),
          sku: z.string().nullish(),
          quantity: z.number(),
          price: z.string(),
        }),
      )
      .nullish(),
  }),
};
